import config from "@app/lib/api/config";
import { Html } from "@react-email/html";
import type React from "react";

export const EmailLayout = ({
  workspace,
  children,
}: {
  workspace: { id: string; name: string };
  children: React.ReactNode;
}) => {
  return (
    <Html>
      <head>
        <title>An email from Dasis about {workspace.name}</title>
      </head>
      <body
        style={{
          fontFamily: "Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif",
          fontSize: "14px",
          backgroundColor: "#ffffff",
          padding: "20px",
        }}
      >
        <div
          style={{
            maxWidth: "600px",
            backgroundColor: "#ffffff",
          }}
        >
          {children}
        </div>
        <div style={{ width: "100%", textAlign: "left", marginTop: "20px" }}>
          <a
            href={config.getStaticWebsiteUrl()}
            target="_new"
            style={{
              fontSize: "18px",
              fontWeight: 700,
              letterSpacing: "-0.02em",
              color: "#1A1A1F",
              textDecoration: "none",
            }}
          >
            Dasis
          </a>
        </div>
        <div
          style={{
            width: "100%",
            textAlign: "left",
            marginTop: "20px",
            fontSize: "12px",
            color: "#969CA5",
          }}
        >
          <div>This is an automated email. Please do not reply.</div>
          <div>
            Manage your notifications in{" "}
            <a
              href={`${config.getAppUrl()}/w/${workspace.id}/me`}
              target="_blank"
              style={{ color: "#DB3D7C" }}
            >
              your profile settings
            </a>
            .
          </div>
        </div>
      </body>
    </Html>
  );
};
